/**
 * WordprocessingML represents fully justified paragraphs as `both`.
 *
 * SuperDoc can export the CSS-flavoured `justify` token. LibreOffice accepts
 * it, while Word can reject a document that contains it even when ZIP and XML
 * validation succeed. Normalise every occurrence instead of relying on that
 * contextual tolerance. This changes only the invalid enum token and
 * preserves the paragraph's alignment and every surrounding byte of OOXML.
 *
 * The tag body stops at `<` as well as `>`: XML forbids `<` inside a tag, and a
 * body that could run past the next tag made a part ending in unterminated
 * `<w:jc ` tags quadratic (200 KB held the gate 28 s, 2026-10-16).
 */
export function repairInvalidParagraphJustification(xml: string): { xml: string; count: number } {
  let count = 0;
  const repaired = xml.replace(
    /(<w:jc\b[^<>]*\bw:val=(['"]))justify\2/g,
    (_match, prefix: string, quote: string) => {
      count += 1;
      return `${prefix}both${quote}`;
    },
  );
  return { xml: repaired, count };
}
